import React, { useState } from 'react';
import { Card, DonutLegendChart } from '@/components/ui';
import type { PlanRevenueData } from '../../types/dashboard.types';

interface PlanRevenueDonutProps {
  data: PlanRevenueData[];
  totalValue: number;
}

export function PlanRevenueDonut({ data, totalValue }: PlanRevenueDonutProps) {
  const [period, setPeriod] = useState('7_days');

  return (
    <Card className="p-6 border-slate-100 shadow-sm flex flex-col h-[320px]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-slate-900">Doanh thu theo gói dịch vụ</h3>
        <select 
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
          className="sm:text-sm text-xs border border-slate-200 rounded-lg px-3 py-1.5 outline-none focus:ring-2 focus:ring-brand-500/20 text-slate-600 bg-slate-50 cursor-pointer"
        >
          <option value="7_days">7 ngày qua</option>
          <option value="30_days">30 ngày qua</option>
        </select>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <DonutLegendChart
          title=""
          centerValue={(totalValue || 0).toLocaleString()}
          centerLabel="tỷ đồng"
          data={data || []}
          total={totalValue || 0}
          valueFormatter={(item) => `${(item?.value || 0).toLocaleString()} tỷ`}
          showLegendPercent={true}
          className="!border-0 !shadow-none !bg-transparent p-0 w-full"
        />
      </div>
    </Card>
  );
}
